var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-edit-layout',{attrs:{"title":_vm.title}},[_c('challenges-form',{attrs:{"id":_vm.id,"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }